import ArticleCard from '@/components/base/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';
import { getLatestArticles } from '@/utils/data';

const latest = getLatestArticles(10);

export default function LatestNews() {
  return (
    <section className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        title="最新资讯"
        subtitle="及时更新，随时掌握娱乐脉搏"
        icon="ri-newspaper-line"
        linkTo="/category/film"
        linkLabel="浏览分类"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3">
        {latest.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>
    </section>
  );
}